import z from 'zod/v4';

import { columns } from './columns';

export * from './base';
export * from './relaxed';
export * from './strict';

export const alphaQuoteLineSchema = z.object(columns);

export type AlphaQuoteLine = z.output<typeof alphaQuoteLineSchema>;
